import get from 'lodash/get';
import { PATIENT_ATTACHMENTS_TYPE } from '../../constants/index';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

const { DOCUMENTS, OUTCOME_ATTACHMENTS } = PATIENT_ATTACHMENTS_TYPE;

export const consts = createReqConsts('profile', 'get-user-attachments', [
  'DELETE_ITEM',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'providers',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'patients',
    {
      type: 'payload',
      selector: ['userId'],
    },
    'documents',
  ],
});

export const getPatientAttachmentsData = data => {
  const { documents = [], outcomeAttachments = [] } = data || {};
  const modifiedDocuments = documents.map((attachment, index) => ({
    ...attachment,
    uniqId: `${DOCUMENTS}-${index}`,
    type: DOCUMENTS,
  }));

  const modifiedOutcomeAttachments = outcomeAttachments.map(
    (attachment, index) => ({
      ...attachment,
      uniqId: `${OUTCOME_ATTACHMENTS}-${index}`,
      type: OUTCOME_ATTACHMENTS,
    }),
  );

  return [...modifiedDocuments, ...modifiedOutcomeAttachments].sort(
    (first, second) =>
      get(first, 'category.name') > get(second, 'category.name') ? 1 : -1,
  );
};

const defaultReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case consts.SUCCEED: {
      return {
        ...state,
        succeed: true,
        sending: false,
        consents: payload.consents,
        paperConsents: payload.paperConsents,
        list: getPatientAttachmentsData(payload),
      };
    }
    case consts.DELETE_ITEM: {
      const { uniqId } = payload;
      const updatedList = get(state, 'list').filter(
        item => item.uniqId !== uniqId,
      );
      return {
        ...state,
        list: updatedList,
      };
    }
    default:
      return defaultReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/profiles/get-user-attachment.js